import React from "react";
import "./AwoofMarketplace.css";
import { Helmet } from "react-helmet-async";

const title = "Awoof Marketplace";
const pageTitle =
  "Awoof Marketplace | Shop Smart & Save with Respected Solutions";
const metaDescription =
  "Discover Awoof Marketplace by Respected Solutions. Shop authentic luxury items, jewellery, watches, cars, phones, and more at unbeatable prices. Great deals, real value, every time.";

const AwoofMarketplace = () => {
  return (
    <section className="awoof-marketplace-container">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Store",
            name: "Awoof Marketplace",
            provider: {
              "@type": "Organization",
              name: "Respected Solutions",
            },
            areaServed: "NG",
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "Awoof Marketplace",
            url: "https://www.respectedsolution.co/awoof-marketplace",
          })}
        </script>
        <title>{pageTitle}</title>
        <meta name="description" content={metaDescription} />
      </Helmet>

      <div
        className="awoof-marketplace-hero-slide"
        style={{ backgroundImage: `url(/assets/images/slider/slider-3.jpeg)` }}
      >
        <div className="awoof-marketplace-hero-overlay">
          <div className="awoof-marketplace-hero-content">
            <h1>{title}</h1>
            <p>Great deals. Real value. Every time.</p>
          </div>
        </div>
      </div>

      <div className="awoof-marketplace-inner">
        <div className="awoof-marketplace-layout">
          <div className="awoof-marketplace-main-content">
            <section className="awoof-marketplace-intro">
              <p>
                Welcome to Awoof Marketplace, the smart way to shop and save
                with Respected Solutions. Here, you'll find authentic luxury
                items from gold, diamonds, fine jewellery, and luxury
                wristwatches to gadgets, cars, phones (Samsung & iPhone), and
                more... all at unbeatable prices.
              </p>
              <p>
                Why "Awoof"? Because every deal here gives you more value for
                less. Whether you're buying a timeless piece of jewellery,
                upgrading your phone, or investing in collectibles, Awoof
                Marketplace ensures you enjoy trusted products, fair prices, and
                real value.
              </p>
            </section>

            <section className="awoof-marketplace-steps">
              <h2>Ready to join the train of Satisfied Customers?</h2>
              <ul>
                <li>
                  <strong>1. Browse Our Collections – </strong> Explore our wide
                  range of jewellery, luxury watches, phones, cars, and more.
                </li>
                <li>
                  <strong>2. Select Your Item – </strong> Choose the product
                  that best suits your need or desire.
                </li>
                <li>
                  <strong>3. Confirm Authenticity – </strong> Every product
                  comes with our Respected Solutions authenticity assurance.
                </li>
                <li>
                  <strong>4. Contact Us to Seal the Deal – </strong> Reach out
                  via phone, email, WhatsApp and Telegram or our official
                  channel to confirm availability.
                </li>
                <li>
                  <strong>5. Secure Payment Delivery – </strong> Pay safely and
                  receive your product with peace of mind, knowing you're backed
                  by Respected Solutions' trusted service.
                </li>
              </ul>
            </section>

            <div className="awoof-marketplace-seo-content">
              <h2>Unbeatable Deals on Luxury & Everyday Items</h2>
              <p>
                Discover pre-owned luxury watches Lagos, discounted gadgets
                Nigeria, and buy used cars Lagos cheap at Awoof Marketplace.
                Shop authentic pre-owned Lagos items with our deal of the day
                Lagos specials. Find second-hand luxury Lagos products including
                electronics, cars, and watches, all verified for quality and
                authenticity.
              </p>
            </div>

            <section className="awoof-marketplace-edge">
              <h2>The Awoof Edge</h2>
              <ul>
                <li>
                  ✅ <strong>Verified Authenticity:</strong> Every item is
                  carefully checked and guaranteed genuine.
                </li>
                <li>
                  ✅ <strong>Unbeatable Prices:</strong> Luxury and everyday
                  items at rates you won't find elsewhere.
                </li>
                <li>
                  ✅ <strong>Wide Variety:</strong> From jewellery and
                  wristwatches to cars, phones (Samsung &amp; iPhone), and more.
                </li>
                <li>
                  ✅ <strong>Trusted Source:</strong> Backed by Respected
                  Solutions' reputation for integrity and excellence.
                </li>
              </ul>
              <p>
                At Awoof Marketplace, it's not just shopping, it's smart buying.
              </p>
              <p>✨ Great deals. Real value. Every time.</p>
              <p>
                Our Whatsapp and Telegram lines are for sales enquiries only.
                <strong> NOT Loan 🚫</strong>
              </p>
            </section>
          </div>

          <aside className="awoof-marketplace-sidebar">
            <div className="awoof-marketplace-channel-card">
              <h3>Join Our Channels</h3>
              <p>Get access to exclusive deals and new arrivals</p>

              <div className="awoof-marketplace-channels">
                <a
                  href="https://whatsapp.com/channel/0029VbBs28bI7BeOM1HWKb1M"
                  className="awoof-marketplace-channel-btn whatsapp"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  WhatsApp Channel
                </a>

                <a
                  href="https://t.me/respected0001"
                  className="awoof-marketplace-channel-btn telegram"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Telegram Channel
                </a>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default AwoofMarketplace;
